import { useTranslation } from 'react-i18next';

import { FormInput } from './FormInput';

interface VerificationCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  onSendCode: () => void;
  error?: string;
  isCodeSent: boolean;
  countdown: number;
  isLoading: boolean;
  disabled?: boolean;
  placeholder?: string;
  // 新增 tabIndex 属性用于控制 tab 顺序
  tabIndex?: number;
}

export const VerificationCodeInput = ({
  value,
  onChange,
  onSendCode,
  error,
  isCodeSent,
  countdown,
  isLoading,
  disabled = false,
  placeholder,
  tabIndex,
}: VerificationCodeInputProps) => {
  const { t } = useTranslation();
  const sendCodeButton = (
    <div className="flex items-center">
      <div className="mr-[12px] h-[14px] w-px bg-[#E0E0E0]" />
      <button
        type="button"
        onClick={onSendCode}
        disabled={disabled || isCodeSent || isLoading}
        className="whitespace-nowrap text-[14px] font-bold text-black hover:text-[#326BFB] disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isCodeSent
          ? t('components.verificationCode.resendCode', { countdown })
          : t('components.verificationCode.sendCode')}
      </button>
    </div>
  );

  return (
    <FormInput
      type="text"
      name="verificationCode"
      id="verificationCode"
      autoComplete="off"
      tabIndex={tabIndex}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || t('components.verificationCode.placeholder')}
      error={error}
      rightElement={sendCodeButton}
    />
  );
};
